import { EnumBase } from 'hay-core-react';
class DashboardPeriodoEnum extends EnumBase {
    constructor() {
        super([
            'main.dashboard.periodo.dia',
            'main.dashboard.periodo.mes',
            'main.dashboard.periodo.ano',
            'main.dashboard.periodo.periodo',
        ], 'main.dashboard.periodo.dia');
    }
}

const instance = new DashboardPeriodoEnum();
export default instance;
